export const SPONSOR_TIERS = [
  {
    id: 'diaper-bag',
    name: 'DIAPER BAG',
    tagline: 'Get your logo on the mini-fridge.',
    perks: [
      'Logo on the practice-room mini-fridge',
      'One ticker rotation per day',
      'Discord channel banner mention'
    ],
    note: 'For the brand that wants to support tired men quietly.'
  },
  {
    id: 'bedtime-bottle',
    name: 'BEDTIME BOTTLE',
    tagline: 'A patch on the sleeve. A name in the recap.',
    perks: [
      'Jersey sleeve patch',
      'Permanent rotation in the scrolling ticker',
      'Shoutout in every match recap',
      'Named sponsorship of one match per month'
    ],
    note: 'For the brand that wants to be seen, but not loudly. Like a good co-parent.'
  },
  {
    id: 'mythic-patron',
    name: 'MYTHIC PATRON',
    tagline: 'Chest patch. Pinned ticker slot. A whole Article.',
    perks: [
      'Jersey chest patch',
      'Pinned slot in the scrolling ticker',
      'Co-branded "DAD INTERMISSION" overlay on every pause segment',
      'Named sponsorship of a Bylaw / Article (e.g. "Article III · Audio · brought to you by …")',
      'Two named match sponsorships per month'
    ],
    note: 'For the brand that wants the kids to ask about you. Limited to one partner per season.'
  }
];
